import React from 'react';
import PropTypes from 'prop-types';

import { HorizontalBarChart } from 'modules/common/chart/BarChart';
import DelayDiv from 'modules/common/components/DelayDiv';
import EmptyState from 'partial/components/EmptyState';
import OrgTable from './OrgTable';

const EmptyPlaceholder = () => <EmptyState statement="There are no items." />;

const format = [
  { id: 'title', label: 'AGENCY', key: 'title' },
  {
    id: 'transactions',
    label: 'TRANSACTIONS',
    key: 'transactions',
    contentClassName: 'text-center',
  },
  { id: 'count', label: 'SMS', key: 'count' },
];

const customChartPadding = {
  rightPadding: 10,
  leftPadding: 50,
};

function TopOrg({ data, isLoading }) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isLoading || !data?.length ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {isLoading ? (
            <div className="grid grid-cols-2 gap-3 p-3">
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
              <div className="animate-pulse bg-neutral-300 h-8 w-full rounded" />
            </div>
          ) : (
            <EmptyPlaceholder />
          )}
        </>
      ) : (
        <div className="flex justify-between">
          <div className="px-3 pt-1 pr-0 min-w-[37%]">
            <OrgTable data={data} format={format} isLoading={isLoading} />
          </div>
          <DelayDiv
            className="flex-grow"
            delay={100}
            loader={
              <div className="col-span-1 bg-neutral-100 animate-pulse rounded-lg" />
            }
          >
            <HorizontalBarChart
              data={data}
              horizontal
              isLoading={isLoading}
              {...customChartPadding}
            />
          </DelayDiv>
        </div>
      )}
    </>
  );
}

TopOrg.defaultProps = {
  data: [],
  isLoading: false,
};

TopOrg.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.instanceOf(Array),
};

export default TopOrg;
